import { SVGFC } from '@repo/toolkit/types'

const ResetTwoIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_12276_381480)">
        <mask
          id="mask0_12276_381480"
          maskUnits="userSpaceOnUse"
          x="2"
          y="2"
          width="18"
          height="19"
        >
          <path d="M2 2.5H20V20.5H2V2.5Z" fill="white" />
        </mask>
        <g mask="url(#mask0_12276_381480)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.5 17.5C11.0913 17.5 12.6174 16.8679 13.7426 15.7426C14.8679 14.6174 15.5 13.0913 15.5 11.5V9.697L13.7907 11.4775C13.7232 11.5513 13.6416 11.6109 13.5508 11.6527C13.4599 11.6946 13.3616 11.7178 13.2616 11.721C13.1616 11.7243 13.062 11.7075 12.9686 11.6716C12.8752 11.6358 12.7899 11.5816 12.7177 11.5123C12.6456 11.443 12.588 11.36 12.5484 11.2681C12.5089 11.1762 12.4881 11.0774 12.4873 10.9773C12.4865 10.8773 12.5057 10.7781 12.5438 10.6856C12.582 10.5931 12.6382 10.5092 12.7093 10.4388L15.7092 7.3135C15.7792 7.24068 15.8632 7.18275 15.9561 7.14317C16.049 7.1036 16.149 7.0832 16.25 7.0832C16.351 7.0832 16.451 7.1036 16.5439 7.14317C16.6368 7.18275 16.7208 7.24068 16.7908 7.3135L19.7908 10.4388C19.8618 10.5092 19.918 10.5931 19.9562 10.6856C19.9943 10.7781 20.0135 10.8773 20.0127 10.9773C20.0119 11.0774 19.9911 11.1762 19.9516 11.2681C19.912 11.36 19.8544 11.443 19.7823 11.5123C19.7101 11.5816 19.6248 11.6358 19.5314 11.6716C19.438 11.7075 19.3384 11.7243 19.2384 11.721C19.1384 11.7178 19.0401 11.6946 18.9492 11.6527C18.8584 11.6109 18.7768 11.5513 18.7092 11.4775L17 9.697V11.5C17 15.6423 13.6423 19 9.5 19C5.35775 19 2 15.6423 2 11.5C2 7.35775 5.35775 4 9.5 4H9.875C10.0739 4 10.2647 4.07902 10.4053 4.21967C10.546 4.36032 10.625 4.55109 10.625 4.75C10.625 4.94891 10.546 5.13968 10.4053 5.28033C10.2647 5.42098 10.0739 5.5 9.875 5.5H9.5C7.9087 5.5 6.38258 6.13214 5.25736 7.25736C4.13214 8.38258 3.5 9.9087 3.5 11.5C3.5 13.0913 4.13214 14.6174 5.25736 15.7426C6.38258 16.8679 7.9087 17.5 9.5 17.5Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_12276_381480">
          <rect width="18" height="18" fill="white" transform="translate(2 2.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ResetTwoIcon
